import { Button, Form, Input } from 'antd';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import ListComponent from './component/ListComponent';
import AddComponent from './component/AddComponent';
import EditComponent from './component/EditComponent';
import useStore from '../../../store';
import PageHeader from '../../../component/PageHeader';
import { PublicSettingsBreadCrumbs } from '../../../config/BreadcrumbConfig';

const PublicSettings = observer(() => {
	const [settingAddModal, setSettingAddModal] = useState(false);
	const [settingEditModal, setSettingEditModal] = useState(false);
	const { PUBLICSETTINGS } = useStore();

	const AddSettingModal = () => {
		setSettingAddModal(true);
	};

	const closeAddModal = () => {
		setSettingAddModal(false);
	};

	const openEdit = () => {
		setSettingEditModal(true);
	};

	const closeEditModal = () => {
		setSettingEditModal(false);
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			PUBLICSETTINGS.searchValue = text;
			PUBLICSETTINGS.setupGrid(PUBLICSETTINGS.agGrid);
		}
	};

	useEffect(() => {
		return () => {
			PUBLICSETTINGS.searchValue = '';
		};
	}, []);

	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={PublicSettingsBreadCrumbs.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Button
						key={2}
						type="primary"
						className="addBtn"
						onClick={AddSettingModal}
					>
						Add Settings
					</Button>,
				]}
			/>
			<ListComponent openEditModal={openEdit} />
			<AddComponent visible={settingAddModal} onClose={closeAddModal} />
			<EditComponent
				visible={settingEditModal}
				onClose={closeEditModal}
			/>
		</div>
	);
});
export default PublicSettings;
